import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@material-ui/core";

const AlertDialog = (prop:any) => {
    return (
        <>
            <Dialog open={prop.open}>
                <DialogTitle>
                    {prop.title}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>{prop.message}</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={prop.handleClose}>Close</Button>
                </DialogActions>
            </Dialog>
        </>
    )
};

export default AlertDialog;